module.exports = __webpack_public_path__ + "img/ico_home_active.2188e6ff.svg";